(function ($) {
	'use strict';

	$(function () {
		const $trigger = $('.js-primary-menu-submenu-trigger');
		const $submenu = $('.js-primary-menu-submenu');
		const $list = $('.js-primary-menu-list');
		const $navLinks = $('[class$=menu-submenu__link]', $submenu);
		let ignoreFocus = false;

		$navLinks.each(function () {
			$(this).on('mousedown', function (e) {
				ignoreFocus = true;
			});

			$(this).on('keydown', function (e) {
				ignoreFocus = false;
			});
		})

		$trigger.on('mouseenter', function () {
			$(this).closest($submenu).addClass('is-active');

			if ($(this).hasClass('primary-menu-submenu__item--two-columns')) {
				$(this).closest($submenu).addClass('is-active--two-columns');
			}

			if ($(this).hasClass('secondary-menu-submenu__item--two-columns')) {
				$(this).closest($submenu).addClass('is-active--two-columns');
			}

			$(this).closest($list).first().css('min-height', $(this).find($list).first().height() + 'px');
		}).on('mouseleave', function () {
			$(this).closest($submenu).removeClass('is-active').removeClass('is-active--two-columns');

			$(this).closest($list).first().css('min-height', '');
		});

		$trigger.on('focusin', function () {
			if (ignoreFocus) return;

			$(this).closest($submenu).addClass('is-active');

			if ($(this).hasClass('primary-menu-submenu__item--two-columns')) {
				$(this).closest($submenu).addClass('is-active--two-columns');
			}

			if ($(this).hasClass('secondary-menu-submenu__item--two-columns')) {
				$(this).closest($submenu).addClass('is-active--two-columns');
			}

			$(this).closest($list).first().css('min-height', $(this).find($list).first().height() + 'px');
		});

		$trigger.on('focusout', function () {
			if (ignoreFocus) return;

			$(this).closest($submenu).removeClass('is-active').removeClass('is-active--two-columns');

			$(this).closest($list).first().css('min-height', '');
		});
	});
})(jQuery);
